import { render, staticRenderFns } from "./kuaishouLiveRooms.vue?vue&type=template&id=0c4fb647"
import script from "./kuaishouLiveRooms.vue?vue&type=script&lang=js"
export * from "./kuaishouLiveRooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports